{
  "pt": {
    "snippets": {
      "labels": {
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "create": "Criar um trecho",
        "delete": "Excluir",
        "edit": "Editar",
        "editTitle": "Editar trecho",
        "initMessage": "Selecione um trecho para visualizá-lo aqui.",
        "language": "Linguagem",
        "linkable": "Tipo",
        "linkableClient": "Equipe",
        "linkableEmployee": "Pessoal",
        "linkablePartner": "Parceiro",
        "manage": "Gerencie seus trechos",
        "manageMessage": "Ou clique aqui para gerenciar todos os seus snippets nas configurações da empresa",
        "message": "Mensagem",
        "messageError": "Por favor, insira uma mensagem.",
        "new": "Novo trecho",
        "noSnippets": "Você ainda não tem trechos de código.",
        "preview": "Pré-visualização",
        "save": "Salvar",
        "search": "Procurar",
        "select": "Selecione",
        "snippets": "Trechos",
        "title": "Título",
        "titleError": "Por favor, insira um título"
      }
    }
  }
}
